<template>
  <div>
    <span class="gray--text text--lighten-1">{{ label }}: </span>
    <v-tooltip 
      v-if="isInvoiceRejected && totalInvoiceErrors"
      :nudge-left="0"
      bottom 
    >
      <template slot="activator">
        <div class="status-nf">
          <img 
            v-if="invoiceStatusIcon"
            :src="require(`@/assets/images/icons/${invoiceStatusIcon}.svg`)"
            class="mr-1"
          >
          <span class="red--text">{{ invoiceStatus }}</span>
          <span 
            v-if="totalInvoiceErrors > 1"
            class="gray--text text--lighten-1"
          >
            <small class="s-nf-plus-reason">(+ {{ totalInvoiceErrors - 1 }})</small>
          </span>
        </div>
      </template>
      <div>
        <p
          v-for="reason in refusalReasons" 
          class="my-1"
        >
          {{ reason }}
        </p>
      </div>
    </v-tooltip>
    <div 
      v-else
      class="status-nf"
    >
      <img 
        v-if="invoiceStatusIcon"
        :src="require(`@/assets/images/icons/${invoiceStatusIcon}.svg`)"
        class="mr-1"
      >
      {{ invoiceStatus }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'InvoiceStatus',
  props: {
    status: {
      type: String,
      required: true
    },
    refusalReasons: {
      type: Array,
      default: null
    },
    label: {
      type: String,
      default: 'Status'
    }
  },
  computed: {
    isInvoiceRejected() {
      return this.status === 'rejected'
    },
    totalInvoiceErrors() {
      return this.refusalReasons?.length
    },
    invoiceStatusIcon() {
      return {
        valid: 'status-success',
        rejected: 'status-error',
        pending: 'status-pending'
      }[this.status]
    },
    invoiceStatus() {
      const firstInvoiceError = (this.refusalReasons || [])[0]
      return {
        valid: 'Aprovada',
        rejected: this.totalInvoiceErrors ? `Rejeitado: ${firstInvoiceError}` : 'Rejeitado',
        pending: 'Produto ou Quantidade não identificados'
      }[this.status]
    }
  }
}
</script>

<style lang="stylus" scoped>

.status-nf {
  align-items: center;
  display: flex;
  line-height: normal;

  .s-nf-plus-reason {
    white-space: nowrap;
  }
}

</style>
